import * as yup from 'yup'

import helpers from 'helpers'

const schema = yup.object().shape({
  categoryId: yup.string().required('Selecione alguma opção'),
  subCategoryId: yup.string().required(),
  title: yup.string().required().max(200),
  description: yup
    .string()
    .required()
    .test(
      'hasContent',
      'Preencha esse campo',
      helpers.validates.jodit.hasContent,
    ),
})

export default schema
